<template>
  <v-dialog
		v-model="dialog"
		persistent
		width="700"
	>
	<v-card class="p-0">
			<!-- Cabecera del formulario -->
			<v-card-title class="headline">
				<v-flex xs9>
					<v-icon>done</v-icon>Aprobar CAS
				</v-flex>
				<v-spacer></v-spacer>
				<v-btn icon @click.native="close()">
					<v-icon>close</v-icon>
				</v-btn>
			</v-card-title>

			<!-- Cuerpo del formulario -->
				<v-card-text>
					<v-container grid-list-md style="min-width: 100%">
						<v-layout wrap row>
            <v-flex xs12 md12>
              <h3 class="detalle">
                <strong>Nombres : </strong> {{ form.nombres }}  {{ form.ap_paterno }}  {{ form.ap_materno }}
              </h3>
            </v-flex>
			<v-flex xs12 md12>
              <h3 class="detalle">
                <strong>Ítem : </strong>
              </h3>
            </v-flex>
            <v-flex xs12 md12>
              <h3 class="detalle">
                <strong>Fecha de presentación en ASP-B:  </strong>
                {{ form.fecha_presentacion }}
              </h3>
            </v-flex>
            <v-flex xs12 md12>
              <h3 class="detalle">
                <strong>Años de calificación a la fecha :</strong>
                {{form.anios }}
              </h3>
            </v-flex>
            <v-flex xs12 md12>
              <h3 class="detalle">
                <strong>Meses de calificación a la fecha :</strong>
                {{form.meses }}
              </h3>
            </v-flex>
			<v-flex xs12 md12>
              <h3 class="detalle">
                <strong>Días calificados a la fecha :</strong>
                {{form.dias }}
              </h3>
            </v-flex>
          </v-layout>
					</v-container>
				</v-card-text>
				<v-card-actions>
				
					<v-spacer></v-spacer>
					<v-btn
						@click.native="close()">
						<v-icon>cancel</v-icon> {{$t('common.cancel') }}
					</v-btn>
					<v-btn
						color="rgb(80,38,217)"
						dark
						type="submit"
						:loading="loading"
						@click="aprobarCas()"
						>
						<v-icon dark>check</v-icon> APROBAR
					</v-btn>
				</v-card-actions>
		
		</v-card>
	</v-dialog>
</template>

<script>
import validate from '@/common/mixins/validate'; // Importación de mixin de validaciones

export default {
	// Definición de mixins importados
	mixins: [validate],
	// Variables iniciales
	data () {
		return {
			dialog: false,
			form: {},
			valid: false,
			loading: false
		}
	},
	mounted () {
		this.$bus.$on('openDialogAprobarCas', item => {
			this.form = item
			this.dialog = true
		})
	},
	methods: {
		close () {
			this.form = {},
			this.loading = false
			this.valid = false
			this.$bus.$emit('closeDialogAprobarCas')
			this.dialog = false
		},
		async aprobarCas(){
			try {
				this.$confirm('Esta seguro de aprobar el Cas?. La acción es irreversible', async() => {
              let usuario=this.$storage.get("user");
              let respuesta = await this.$service.graphql({
                query: `
                            query{
                              runQuery(consulta:"select persona.fn_aprobar_cas(${parseInt(this.form.id_cas)},${usuario.id})"){
                              respuesta
                              }
                            }
                          `,
              });
              respuesta =
                respuesta.runQuery.respuesta[0].fn_aprobar_cas;
              let resps = respuesta.split("|");
              if (resps[0]=="1") {
                  this.$message.info("El cas fué aprobado exitosamente");
                  this.close()
              }else{
                this.$message.error(resps[1]);
              }
          });
			} catch (error) {
				copnsole.log(error)
			}
		}
	}
}
</script>

<style>
  .detalle {
  font-size: 1.07em;
  color: rgb(24, 22, 134);
}
.detalleSubtitulo {
  font-size: 1.45em;
  color: rgb(24, 22, 134);
}
  </style>



// WEBPACK FOOTER //
// src/components/admin/lista_personal_cas/dialogs/AprobarCas.vue